import { render, staticRenderFns } from "./CategorySummary.vue?vue&type=template&id=53b46109&scoped=true&"
import script from "./CategorySummary.vue?vue&type=script&lang=js&"
export * from "./CategorySummary.vue?vue&type=script&lang=js&"
import style0 from "./CategorySummary.vue?vue&type=style&index=0&id=53b46109&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b46109",
  null
  
)

export default component.exports